import style from './home-screen.module.scss'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { CoreChargeWorkouts } from 'src/component/core-charge-workouts/core-charge-workouts'
import { ExpressWorkouts } from 'src/component/express-workouts-home-section/express-workouts'
import { HomeFeaturedWorkouts } from 'src/component/featured-workouts/home-featured-workouts'
import { FlexFlowWorkouts } from 'src/component/flex-flow-workouts/flex-flow-workouts'
import { LetsGetMoving } from 'src/component/lets-get-moving/lets-get-moving'
import { TrainersSection } from 'src/component/trainers-section/trainers-section'
import { PickUsernameModal } from 'src/component/pick-username-modal'

export const HomeScreen = (): React.ReactElement => {
  return (
    <div>
      {/* `noGutters` on every Row, deliberately. Home is the one screen that renders Rows
          straight into a bare <div> with no Container, and Bootstrap 4 gives `.row` a
          `margin: 0 -15px` that a Container's own 15px padding normally absorbs. Without
          one those negative margins overflow the viewport by 30px, which raises a
          horizontal scrollbar, which eats viewport height, which makes the
          `min-height: 100vh` on `.app-flex-root` overflow vertically too — a small,
          permanent scroll on a page that fits. `noGutters` zeroes the row margin and the
          matching column padding together, so content lands in exactly the same place it
          did before, minus the overflow. Each section manages its own width through its
          own Container, which is why adding one here would fight the full-bleed
          backgrounds instead. (GH-904) */}
      {/* Above LetsGetMoving — web's suggested-series section — which is the PRD's "above the
          suggested series". Web has no Training Calendar strip, so this is the top of Home.

          `whiteBg` on the Row, same as the Express and Flex Flow sections: the section's own
          `Container` is max-width constrained, so a background set only there would stop short
          of the viewport edges instead of running full-bleed. */}
      <Row noGutters className={style.whiteBg}>
        <Col>
          <HomeFeaturedWorkouts />
        </Col>
      </Row>
      <Row noGutters>
        <Col>
          <LetsGetMoving />
        </Col>
      </Row>
      <Row noGutters className={style.whiteBg}>
        <Col>
          <ExpressWorkouts />
        </Col>
      </Row>
      <Row noGutters>
        <Col>
          <CoreChargeWorkouts />
        </Col>
      </Row>
      <Row noGutters className={style.whiteBg}>
        <Col>
          <FlexFlowWorkouts />
        </Col>
      </Row>
      <Row noGutters>
        <Col>
          <TrainersSection />
        </Col>
      </Row>
      <PickUsernameModal />
    </div>
  )
}
